var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00033 1.83464L2.00033 1.8413M2.00033 6.5013L2.00033 6.50797M2.00033 11.168L2.00033 11.1746M2.00033 2.5013C1.63214 2.5013 1.33366 2.20283 1.33366 1.83464C1.33366 1.46645 1.63214 1.16797 2.00033 1.16797C2.36852 1.16797 2.66699 1.46645 2.66699 1.83464C2.66699 2.20283 2.36852 2.5013 2.00033 2.5013ZM2.00033 7.16797C1.63214 7.16797 1.33366 6.86949 1.33366 6.5013C1.33366 6.13311 1.63214 5.83464 2.00033 5.83464C2.36852 5.83464 2.66699 6.13311 2.66699 6.5013C2.66699 6.86949 2.36852 7.16797 2.00033 7.16797ZM2.00032 11.8346C1.63214 11.8346 1.33366 11.5362 1.33366 11.168C1.33366 10.7998 1.63214 10.5013 2.00033 10.5013C2.36851 10.5013 2.66699 10.7998 2.66699 11.168C2.66699 11.5362 2.36851 11.8346 2.00032 11.8346Z",
    stroke: "#5F6C8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu_dots.de7c8f04e9f461d73294d7c6abdc7ba0.svg";
export { ForwardRef as ReactComponent };